export const DUMMY_CONVERSATIONS = [
  {
    id: "1",
    name: "Kovaleski, Winston",
    subtitle: "North/202/A (In-house)",
    time: "Today",
    showExternal: true,
    avatarLabel: "KW",
  },
  {
    id: "2",
    name: "Jane Doe, You",
    subtitle: "North/202/A (In-house)",
    time: "Today",
    showExternal: true,
    avatarLabel: "JD",
  },
  {
    id: "3",
    name: "Beaufort, Annelise",
    subtitle: "North/202/A (In-house)",
    time: "Today",
    showExternal: false,
    avatarLabel: "BA",
  },
  {
    id: "4",
    name: "Thompson, Gerald",
    subtitle: "South/101/B (In-house)",
    time: "Yesterday",
    showExternal: false,
    avatarLabel: "TG",
  },
  {
    id: "5",
    name: "Martinez, Sofia",
    subtitle: "East/305/C (In-house)",
    time: "Jun 28",
    showExternal: true,
    avatarLabel: "MS",
  },
];

export const DUMMY_TEAM_CONVERSATIONS = [
  {
    id: "t1",
    name: "ICU Care Team",
    subtitle: "North/Wing A",
    time: "Today",
    showExternal: false,
    avatarLabel: "IC",
  },
  {
    id: "t2",
    name: "Nursing Staff",
    subtitle: "South/Wing B",
    time: "Today",
    showExternal: false,
    avatarLabel: "NS",
  },
  {
    id: "t3",
    name: "Physiotherapy Team",
    subtitle: "East/Wing C",
    time: "Yesterday",
    showExternal: true,
    avatarLabel: "PT",
  },
  {
    id: "t4",
    name: "Dietary & Nutrition",
    subtitle: "West/Wing D",
    time: "Jun 30",
    showExternal: false,
    avatarLabel: "DN",
  },
];

export const DUMMY_ARCHIVED_CONVERSATIONS = [
  {
    id: "a1",
    name: "Reynolds, Dorothy",
    subtitle: "North/104/B (Discharged)",
    time: "Jun 20",
    showExternal: false,
    avatarLabel: "RD",
  },
  {
    id: "a2",
    name: "Harrington, James",
    subtitle: "South/203/A (Discharged)",
    time: "Jun 15",
    showExternal: true,
    avatarLabel: "HJ",
  },
  {
    id: "a3",
    name: "Patel, Priya",
    subtitle: "East/301/C (Transferred)",
    time: "Jun 10",
    showExternal: false,
    avatarLabel: "PP",
  },
];

